import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { TopToolbarComponent } from './components/top-toolbar/top-toolbar.component';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import { MenuComponent } from './components/menu/menu.component';
import { MobileBottomNavComponent } from './components/mobile-bottom-nav/mobile-bottom-nav.component';
import { SelectAutocompleteService } from './services/select-autocomplete.service';
import { ExcelFileService } from './services/excel-file.service';
import { UserRoleDirective } from './directives/user-role.directive';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@NgModule({
  declarations: [TopToolbarComponent, MenuComponent, MobileBottomNavComponent],
  exports: [TopToolbarComponent, MenuComponent, MobileBottomNavComponent, UserRoleDirective],
  imports: [CommonModule, SharedModule, NgOptimizedImage, UserRoleDirective, NgxMatSelectSearchModule],
  providers: [ExcelFileService, SelectAutocompleteService],
})
export class CoreModule {}
